import { useRef, useEffect } from 'react';

export default function useResizable(ref, callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        callbackRef.current?.(entries[0].contentRect);
      });
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [ref.current]);
}
